"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSlice = exports.validateDamage = void 0;
var validateSlice = exports.validateSlice = function validateSlice(slice) {
  var damages = slice.damages;
  var validation = damages.reduce(function (validation, damage) {
    var _validateDamage = validateDamage(damage, slice),
      errors = _validateDamage.errors,
      isValid = _validateDamage.isValid;
    validation.isValid = validation.isValid && isValid;
    validation.errors.push(errors);
    return validation;
  }, {
    isValid: true,
    errors: []
  });
  return validation;
};
var validateDamage = exports.validateDamage = function validateDamage(damage, slice) {
  var _validatorData$damage = validatorData[damage.type],
    errors = _validatorData$damage.errors,
    validators = _validatorData$damage.validators;
  var validation = validators.reduce(function (validation, validator, i) {
    if (!validator(damage, slice)) {
      validation.isValid = false;
      validation.errors.push(errors[i]);
    }
    return validation;
  }, {
    isValid: true,
    errors: []
  });
  return validation;
};
var validatorData = {
  HEART: {
    validators: [function (_ref, _ref2) {
      var shellThickness = _ref.shellThickness;
      var diameter = _ref2.diameter;
      return shellThickness <= diameter / 2;
    }, function (_ref3) {
      var shellThickness = _ref3.shellThickness;
      return shellThickness > 0;
    }],
    errors: ["Shell thickness is too large", "Shell thickness is too small"]
  },
  SHELL: {
    validators: [function (_ref4, _ref5) {
      var damageDepth = _ref4.damageDepth;
      var diameter = _ref5.diameter;
      return damageDepth <= diameter / 2;
    }, function (_ref6) {
      var damageDepth = _ref6.damageDepth;
      return damageDepth > 0;
    }],
    errors: ["Damage depth is too large", "Damage depth is too small"]
  },
  POCKET: {
    validators: [function (_ref7) {
      var pocketDiameter = _ref7.pocketDiameter,
        shellThickness = _ref7.shellThickness;
      return pocketDiameter > 0 && shellThickness > 0;
    }, function (_ref8, _ref9) {
      var pocketDiameter = _ref8.pocketDiameter,
        shellThickness = _ref8.shellThickness;
      var diameter = _ref9.diameter;
      return pocketDiameter + shellThickness < diameter;
    }],
    errors: ["Zero is not acceptable for shell thickness or pocket diameter", "Invalid pocket and shell thickness combination"]
  },
  WEDGE: {
    validators: [function (_ref10) {
      var circumferenceMissing = _ref10.circumferenceMissing,
        depthMissing = _ref10.depthMissing;
      return circumferenceMissing > 0 && depthMissing > 0;
    }, function (_ref11, _ref12) {
      var circumferenceMissing = _ref11.circumferenceMissing;
      var diameter = _ref12.diameter;
      return circumferenceMissing <= diameter / 2 * Math.PI;
    }, function (_ref13, _ref14) {
      var depthMissing = _ref13.depthMissing;
      var diameter = _ref14.diameter;
      return depthMissing <= diameter / 2;
    }],
    errors: ["Zero is not acceptable for circumference or depth", "Circumference missing must be less than 1/2 of the pole circumference", "Depth missing must be less than the pole radius"]
  },
  SECTION: {
    validators: [function (_ref15) {
      var circumferenceMissing = _ref15.circumferenceMissing;
      return circumferenceMissing > 0;
    }, function (_ref16, _ref17) {
      var circumferenceMissing = _ref16.circumferenceMissing;
      var diameter = _ref17.diameter;
      return circumferenceMissing <= diameter * Math.PI / 2;
    }, function (_ref18, _ref19) {
      var depthMissing = _ref18.depthMissing;
      var diameter = _ref19.diameter;
      return depthMissing < diameter / 2;
    }, function (_ref20) {
      var shellThickness = _ref20.shellThickness,
        depthMissing = _ref20.depthMissing;
      return depthMissing >= shellThickness;
    }, function (_ref21) {
      var shellThickness = _ref21.shellThickness;
      return shellThickness >= 0;
    }],
    errors: ["Missing circumference is too small!", "Missing circumference is too large!", "Missing depth is too large!", "The missing depth is less than or equal to the shell thickness", "Shell thickness is too small"]
  },
  SLICE: {
    validators: [function (_ref22) {
      var angleToDamage = _ref22.angleToDamage;
      return angleToDamage < 360;
    }, function (_ref23) {
      var depthMissing = _ref23.depthMissing,
        widthMissing = _ref23.widthMissing;
      return widthMissing ? widthMissing > 0 : depthMissing > 0;
    }, function (_ref24, _ref25) {
      var widthMissing = _ref24.widthMissing;
      var diameter = _ref25.diameter;
      return widthMissing ? widthMissing <= diameter : true;
    }, function (_ref26, _ref27) {
      var depthMissing = _ref26.depthMissing;
      var diameter = _ref27.diameter;
      return depthMissing ? depthMissing <= diameter / 2 : true;
    }],
    errors: ["Angle must be less than 360", "Zero is not acceptable for width or depth", "Width missing must be less than the pole diameter!", "Depth missing must be less than the pole radius!"]
  },
  CAVITY: {
    validators: [function (_ref28) {
      var angleToOpening = _ref28.angleToOpening;
      return angleToOpening < 360;
    }, function (_ref29) {
      var circumferenceMissing = _ref29.circumferenceMissing;
      return circumferenceMissing > 0;
    }, function (_ref30, _ref31) {
      var circumferenceMissing = _ref30.circumferenceMissing;
      var diameter = _ref31.diameter;
      return circumferenceMissing <= diameter * Math.PI / 2;
    }, function (_ref32) {
      var shellThicknessAtOpening = _ref32.shellThicknessAtOpening;
      return shellThicknessAtOpening > 0;
    }, function (_ref33, _ref34) {
      var shellThicknessAtOpening = _ref33.shellThicknessAtOpening,
        nestDiameter = _ref33.nestDiameter;
      var diameter = _ref34.diameter;
      return shellThicknessAtOpening + nestDiameter < diameter;
    }],
    errors: ["Angle must be less than 360", "Missing circumference is too small", "Missing circumference is too large", "Zero is not acceptable for nest diameter", "Nest diameter is too large"]
  },
  BOLT: {
    validators: [function (_ref35) {
      var angleToOpening = _ref35.angleToOpening;
      return angleToOpening < 360;
    }, function (_ref36, _ref37) {
      var holeDiameter = _ref36.holeDiameter;
      var diameter = _ref37.diameter;
      return holeDiameter < diameter / 2;
    }, function (_ref38, _ref39) {
      var holeDiameter = _ref38.holeDiameter;
      var diameter = _ref39.diameter;
      return holeDiameter > 0;
    }],
    errors: ['Angle must be less than 360', "Bolt hole is too large", "Bolt hole is too small"]
  }
};

//// if the validators are false, if false message is thrown

// heart:
// shellthickness <= diameter / 2 - 1
// //if false message: "Value is too large"

// shell:
// damageDepth <= diameter / 2 - 1
//if false message: "Value is too large"

// pocketDiameter > 0 && shellThickness > 0
// //if false message: "Zero is not acceptable for shell thickness or pocket diameter"
// pocketDiameter + shellThickness < (diameter - 1)
//if false message: "Invalid pocket and shell thickness combination"

// wedge:
// circumferenceMissing > 0 && depthMissing > 0
// //if false message: "Zero is not acceptable for circumference or depth"
// circumferenceMissing <= poleDiameter / 2 * Math.PI
// //if false message: "Width missing must be less than 1/2 of the pole circumference"
// depthMissing <= poleDiameter / 2
// //if false message: "Depth missing must be less than the pole radius"

// section:
// circumferenceMissing > 0
// //if false message: "Zero is not acceptable for missing circumference"
// depthMissing < poleDiameter / 2 - 1
// //if false message: "Missing depth is too large!"
// depthMissing >= shellThickness
// //if false message: "The missing depth is less than or equal to the shell thickness"

// slice:
// angleToDamage < 360
// //if false message: "Angle must be less than 360"
// widthMissing ? widthMissing > 0 : depthMissing > 0
// //if false message: "Zero is not acceptable for width or depth"
// widthMissing ? widthMissing >= poleDiameter : depthMissing <= poleDiameter / 2
// //if false message: "Depth missing must be less than the pole radius!"
// //if false message: "Width missing must be less than the pole diameter!"

// Cavity:
// angleToDamage < 360
// //if false message: "Angle must be less than 360"
// circumferenceMissing > 0
// //if false message: "Zero is not acceptable for missing circumference"
// shellThicknessAtOpening > 0
// //if false message: "Zero is not acceptable for nest diameter"
// shellThicknessAtOpening + nestDiameter < poleDiameter
// //if false message:  "Nest diameter is too large"

// bolt:
// angleToOpening < 360
// //if false message: 'Angle must be less than 360'
// holeDiameter < poleDiameter / 2 - 1
// //if false message: "Bolt hole is too large"